(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["details-hero"] && !Shopify.designMode) return;
  try {
    
  jQuery.noConflict();
  (($) => {
    $(document).ready(function () {
      $('.services-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-brands"] && !Shopify.designMode) return;
  try {
    
  jQuery.noConflict();
  (($) => {
    $(document).ready(function () {
      $('.brands-slider').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        arrows: false,
        dots: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 430,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"] && !Shopify.designMode) return;
  try {
    
  jQuery.noConflict();
  (($) => {
    $(document).ready(function () {
      $('.homepage-hero').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();
})();
